module.exports = __webpack_public_path__ + "h5/img/icon_zj_cur.93ab4d38.png";